import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import {
  AccessibilityReadOnly,
  Arrow,
  ContainerMenuItem,
  MenuItem,
  MenuItemLink,
  MenuItemText,
  SubMenuContainer,
} from "./styles";

type Page = {
  name?: string;
  slug?: string[];
  icon?: any;
  key?: string;
  url?: string;
  arialLabel?: string;
  showLink?: boolean;
  subMenu?: SubMenu;
  param?: any;
  type?: string;
};

type SubMenu = Page[];

type NavbarLinkProps = {
  page?: Page;
  isSelected: boolean;
  selected: string;
  Icon: any;
  openSub: boolean;
  setCloseMenu?: any;
};

const NavbarLink = ({
  page,
  isSelected,
  selected,
  openSub,
  setCloseMenu,
  ...rest
}: NavbarLinkProps): JSX.Element => {
  const subMenuRef = useRef(null);
  const [subMenuHeight, setSubMenuHeight] = useState(0);
  const [openSubMenu, setOpenSubMenu] = useState(openSub);
  const [forceUpdate, setForceUpdate] = useState(false);

  const Icon = page?.icon;

  useEffect(() => {
    if (subMenuRef && subMenuRef.current) {
      const el = subMenuRef.current;
      setSubMenuHeight(el.childNodes.length * 53 - 15);
    }
  }, [subMenuRef, page]);

  useEffect(() => {
    if (setCloseMenu) {
      setCloseMenu();
    }
  }, [forceUpdate]);

  return (
    <MenuItem {...rest} hidden={!page.showLink} key={page.key}>
      {!page.subMenu && page.showLink && (
        <ContainerMenuItem>
          <Link
            to={`/${page.url}`}
            onClick={() => setForceUpdate(!forceUpdate)}
          >
            <MenuItemLink className="MenuItem" selected={isSelected}>
              <div>
                <Icon className="icon-navbar-link align-item-menu" />
                <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
              </div>
              <AccessibilityReadOnly>
                {isSelected ? "Página atual" : ""}
              </AccessibilityReadOnly>
            </MenuItemLink>
          </Link>
        </ContainerMenuItem>
      )}
      {page.subMenu && (
        <ContainerMenuItem>
          <MenuItemLink
            className="MenuItem"
            selected={isSelected}
            onClick={() => setOpenSubMenu(!openSubMenu)}
          >
            <div>
              <Icon className="icon-navbar-link align-item-menu" />
              <MenuItemText isSelected={isSelected}>{page.name}</MenuItemText>
            </div>
            <Arrow open={openSubMenu} />
          </MenuItemLink>
          <SubMenuContainer
            ref={subMenuRef}
            height={subMenuHeight}
            open={openSubMenu}
          >
            {page.subMenu.map((submenu) => {
              if (submenu.showLink) {
                const isSelectedSub = submenu.slug.includes(selected);
                return (
                  <Link to={`/${submenu.url}`} aria-label={submenu.arialLabel}>
                    <MenuItemText isSelected={isSelectedSub}>
                      {submenu.name}
                    </MenuItemText>
                    <AccessibilityReadOnly>
                      {isSelectedSub ? "Página atual" : ""}
                    </AccessibilityReadOnly>
                  </Link>
                );
              }
              return null;
            })}
          </SubMenuContainer>
        </ContainerMenuItem>
      )}
    </MenuItem>
  );
};

export default NavbarLink;
